import { Controller } from "stimulus"

// #1858: Gekoppelde sporters in het trainerprofiel. Zoeken op naam,
// selecteren (ook alles wat zichtbaar is), het aantal tellen en voor het
// overzetten bevestigen met het aantal en de gekozen trainer. Het overzetten
// zelf doet SporterTransfersController (Ticket 831).
export default class extends Controller {
  static targets = ["zoek", "rij", "vink", "alles", "teller", "doel", "geenResultaat", "formulier"]
  static values = { bevestig: String, teller: String, kies: String }

  connect() {
    this.tel()
  }

  zoek() {
    const term = this.zoekTarget.value.trim().toLowerCase()
    let zichtbaar = 0
    this.rijTargets.forEach((rij) => {
      const past = !term || rij.dataset.naam.includes(term)
      rij.hidden = !past
      if (past) zichtbaar += 1
    })
    if (this.hasGeenResultaatTarget) this.geenResultaatTarget.hidden = zichtbaar > 0
    this.werkAllesBij()
  }

  alles() {
    const aan = this.allesTarget.checked
    this.vinkTargets.forEach((vink) => {
      if (!vink.closest("tr").hidden) vink.checked = aan
    })
    this.tel()
  }

  tel() {
    if (this.hasTellerTarget) {
      this.tellerTarget.textContent = this.tellerValue.replace("%{aantal}", this.gekozen().length)
    }
    this.werkAllesBij()
  }

  bevestig(event) {
    const aantal = this.gekozen().length
    const doel = this.hasDoelTarget ? this.doelTarget : null
    if (aantal === 0 || !doel || !doel.value) {
      event.preventDefault()
      window.alert(this.kiesValue)
      return
    }
    const trainer = doel.options[doel.selectedIndex].text
    const tekst = this.bevestigValue.replace("%{aantal}", aantal).replace("%{trainer}", trainer)
    if (!window.confirm(tekst)) event.preventDefault()
  }

  gekozen() {
    return this.vinkTargets.filter((vink) => vink.checked)
  }

  werkAllesBij() {
    if (!this.hasAllesTarget) return

    const zichtbaar = this.vinkTargets.filter((vink) => !vink.closest("tr").hidden)
    this.allesTarget.checked = zichtbaar.length > 0 && zichtbaar.every((vink) => vink.checked)
  }
}
